module.exports = __webpack_public_path__ + "static/img/Goddess of Victory Nikke.1641a174.png";